import { render, staticRenderFns } from "./Paragraphe.vue?vue&type=template&id=6d8606ac"
import script from "./Paragraphe.vue?vue&type=script&lang=js"
export * from "./Paragraphe.vue?vue&type=script&lang=js"
import style0 from "./Paragraphe.vue?vue&type=style&index=0&id=6d8606ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports